/* nabi — collection grid: tone chips filter (client-side), sort select */
(function () {
  'use strict';
  const sec = document.querySelector('[data-collection-grid]');
  if (!sec || sec.dataset.bound) return; sec.dataset.bound = '1';
  const grid = sec.querySelector('[data-grid]');
  const chips = sec.querySelector('[data-filters]');
  const count = sec.querySelector('[data-count]');
  const cards = grid ? [...grid.children] : [];
  const norm = s => (s || '').toLowerCase().replace(/,/g, '').trim();
  const tonesOf = c => (c.dataset.t || '').split('|').map(norm).filter(Boolean);
  const label = (n, tone) => {
    const d = count.dataset;
    if (tone) return (n === 1 ? d.pieceIn : d.piecesIn.replace('#', n)).replace('@', tone);
    return n === 1 ? d.piece : d.pieces.replace('#', n);
  };
  const apply = f => {
    if (!grid) return;
    const key = norm(f);
    if (chips) chips.querySelectorAll('.chip').forEach(c => c.classList.toggle('on', norm(c.dataset.f) === key || (key === 'all' && c.dataset.f === 'all')));
    cards.forEach(c => c.classList.add('dim'));
    setTimeout(() => {
      let n = 0, name = '';
      cards.forEach(c => { const show = key === 'all' || tonesOf(c).includes(key); c.classList.toggle('hide', !show); if (show) n++; });
      requestAnimationFrame(() => requestAnimationFrame(() => cards.forEach(c => c.classList.remove('dim'))));
      if (chips && key !== 'all') { const chip = [...chips.querySelectorAll('.chip')].find(c => norm(c.dataset.f) === key); name = chip ? chip.textContent.trim() : f; }
      if (count) count.textContent = label(n, key === 'all' ? '' : name);
    }, 200);
  };
  if (chips) {
    const all = chips.querySelector('[data-count-all]'); if (all) all.textContent = '(' + cards.length + ')';
    chips.addEventListener('click', e => { const b = e.target.closest('.chip'); if (b) apply(b.dataset.f); });
  }
  document.querySelectorAll('[data-filter]').forEach(a => a.addEventListener('click', e => { apply(a.dataset.filter); }));
  const sort = sec.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
  /* deep link: #all?tone=… or ?tone= */
  const u = new URL(location.href); const t = u.searchParams.get('tone'); if (t) apply(t);
})();
